







import {Vue, Component} from 'vue-property-decorator';
import TabMenu from 'primevue/tabmenu';

@Component({
    components: {
        TabMenu: Vue.extend(TabMenu)
    }
})
export default class App extends Vue {
    items = [
        {label: 'Home', icon: 'pi pi-fw pi-home', to: '/'},
        {label: 'Teams', icon: 'pi pi-fw pi-cloud', to: '/teams'},
        {label: 'About', icon: 'pi pi-fw pi-info', to: '/about'},
        {label: 'Output', icon: 'pi pi-fw pi-file-pdf', to: '/output'},
        // {label: 'Logout', icon: 'pi pi-fw pi-sign-out', command: () => {this.$store.state.msalInstance.logout()}},
    ]
}
